module.exports = __webpack_public_path__ + "img/bg3.92aed559.png";